import { Link } from "react-router-dom";
import ScrollRow from "@components/layout/ScrollRow";
import topOne from "@svg/1.png";
import topTwo from "@svg/2.png";
import topThree from "@svg/3.png";
import topFour from "@svg/4.png";
import topFive from "@svg/5.png";
import topSix from "@svg/6.png";
import topSeven from "@svg/7.png";

const topNumberImages = [
  topOne,
  topTwo,
  topThree,
  topFour,
  topFive,
  topSix,
  topSeven,
];
const topNumberStyle = [
  { width: 178, height: 248, top: 42 },
  { width: 210, height: 276, top: 28 },
  { width: 210, height: 276, top: 28 },
  { width: 214, height: 276, top: 28 },
  { width: 210, height: 276, top: 28 },
  { width: 210, height: 276, top: 28 },
  { width: 210, height: 276, top: 28 },
];

export default function TopSevenSection({ items }) {
  const topSevenItems = items.slice(0, 7);

  return (
    <section className="home-top-row" style={{ padding: "28px 52px 48px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <span
          style={{
            width: 119,
            height: 48,
            fontFamily: "'Jost', sans-serif",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: 40,
            lineHeight: "120%",
            display: "flex",
            alignItems: "center",
            letterSpacing: "0.02em",
            background:
              "linear-gradient(147.64deg, #FFFFFF 19.39%, #354BCA 133.93%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          ТОП-7
        </span>
        <span
          style={{
            fontSize: 32,
            fontWeight: 600,
            color: "#fff",
            textTransform: "uppercase",
          }}
          className="jost-s"
        >
          недели
        </span>
      </div>

      <ScrollRow cardStyle="393px">
        {topSevenItems.map((item, index) => {
          const Wrapper = item.href ? Link : "div";
          const wrapperProps = item.href ? { to: item.href } : {};

          return (
            <Wrapper
              key={item.title || index}
              {...wrapperProps}
              style={{
                position: "relative",
                width: 393,
                height: 332,
                flex: "0 0 auto",
                overflow: "visible",
                color: "inherit",
                cursor: item.href ? "pointer" : "default",
                display: "block",
                textDecoration: "none",
              }}
            >
            <div
              style={{
                position: "relative",
                width: 393,
                height: 332,
              }}
            >
              <img
                src={topNumberImages[index]}
                alt=""
                aria-hidden="true"
                style={{
                  position: "absolute",
                  left: 0,
                  top: topNumberStyle[index].top,
                  width: topNumberStyle[index].width,
                  height: topNumberStyle[index].height,
                  objectFit: "contain",
                  objectPosition: "center",
                  zIndex: 0,
                  pointerEvents: "none",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  left: 169,
                  top: 0,
                  zIndex: 2,
                  width: 224,
                  height: 332,
                  borderRadius: 12,
                  border: "1px solid rgba(255, 255, 255, 0.09)",
                  overflow: "hidden",
                  background: "#111",
                  boxShadow:
                    "0px 90px 36px rgba(0, 0, 0, 0.01), 0px 50px 30px rgba(0, 0, 0, 0.05), 0px 22px 22px rgba(0, 0, 0, 0.09), 0px 6px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            </Wrapper>
          );
        })}
      </ScrollRow>
    </section>
  );
}
